import styled from "styled-components";

export const HelpContainer = styled.div`
	margin: 20px 0;
	line-height: 1.6;
`;

export const CommandList = styled.div`
	margin-top: 16px;
`;

export const Command = styled.div`
	margin: 8px 0;
	display: flex;
`;

export const CommandName = styled.span`
	color: #00ff00;
	font-weight: bold;
	width: 120px;
	display: inline-block;
`;

export const CommandDesc = styled.span`
	color: #00cc00;
`;
